import { render, staticRenderFns } from "./livetv.vue?vue&type=template&id=06bda7b2&lang=pug&"
import script from "./livetv.vue?vue&type=script&lang=js&"
export * from "./livetv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports